import {
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  Drawer,
  Dropdown,
  Flex,
  Menu,
  Pagination,
  Result,
  Row,
  Space,
  Switch,
  Table,
} from "antd";
import React, { useState } from "react";
import FilterListOutlinedIcon, {
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import GlobalFilter from "../global-filter/GlobalFilter";
import "./CustomTable.css";
import CommonBottomDrawer from "../commonBottomDrawer/CommonBottomDrawer";

import CardViewIcon from "../../../images/sidenavIcons/view_day.png";
import TabsWithExtraBtn from "../tabs-with-extra-content/TabsWithExtraBtn";
import SecurityTabs from "../../Modules/SC/sca-dashboard/components/SecurityTabs.js";
import PopularityTabs from "../../Modules/SC/sca-dashboard/components/PopularityTabs.js";
import MaintenanceTabs from "../../Modules/SC/sca-dashboard/components/MaintenanceTabs.js";
import DocumentListTable from "../../../components/DocumentList/DocumentListTable";
import Findings from "../../../components/findings/Findings";
import TimeLineComponet from "../../../components/timeline/TimeLineComponet";
import DataGridCard from "../data-grid-card-view/DataGridCard";
import FormStep from "../steps/FormStep";
import DynamicForm from "../../../components/SelectComponent/DynamicForm";
import dataForm from "../../../components/dashboard-options/Data";
import SmallModal from "../small-pop-modal/SmallModal";
import warningIcon from "../../../../src/images/otherIcons/warningIcon.svg";
import "./CustomTableVulnerability.css";
import { ReactComponent as ExclamationIcon } from "../../../images/icons/exclamation.svg";
import { ReactComponent as CheckIcon } from "../../../images/icons/done.svg";
import { ReactComponent as CrossIcon } from "../../../images/icons/close.svg";
import { size } from "lodash";
import CircularPieChart from "../../Modules/SC/sca-dashboard/components/CircularPieChart.js";
import CommanPieChart from "../../Modules/SC/sca-dashboard/components/CommanPieChart.js";
import CollapseTopIssues from "../../Modules/SC/sca-dashboard/components/CollapseTopIssues.js";
import AffectedSoftware from "../../Modules/SC/sca-dashboard/components/AffectedSoftware.js";
import SolutionFix from "../../Modules/SC/sca-dashboard/components/SolutionFix.js";
import References from "../../Modules/SC/sca-dashboard/components/References.js";
import RowSelectBtn from "./RowSelectBtn.js";
import SplitscreenOutlinedIcon from "@mui/icons-material/SplitscreenOutlined";

const CustomTableVulnerabilities = ({
  data,
  applyOnRowHandler,
  componentModal,
}) => {
  console.log("data-->", data);
  const { applicationInfoFormData } = dataForm;

  const keys = data?.length > 0 ? Object.keys(data[0]) : [];
  console.log("keys log-->", keys);

  const [columnsVisible, setColumnsVisible] = useState(keys);
  console.log("columnsVisible key-->", columnsVisible);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [tableView, setTableView] = useState(false);
  const [open, setOpen] = useState(false);
  const [componentOpen, setComponentOpen] = useState(false);
  const [openAddAndriodModal, setOpenAddAndriodModal] = useState(false);

  const openAndriodModal = () => {
    setOpenAddAndriodModal(true);
  };
  const closeAndriodModal = () => {
    setOpenAddAndriodModal(false);
  };
  const toggleTableView = () => {
    setTableView(!tableView);
  };
  const showDrawerModal = () => {
    setOpen(true);
  };
  const showComponentModal = () => {
    setComponentOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const onComponentClose = () => {
    setComponentOpen(false);
  };

  const handleSwitchFilter = (checked) => {
    setShowGlobalFilter(checked);
  };

  const toggleColumn = (columnKey) => {
    const updatedVisibleColumns = columnsVisible.includes(columnKey)
      ? columnsVisible.filter((key) => key !== columnKey)
      : [...columnsVisible, columnKey];
    setColumnsVisible(updatedVisibleColumns);
  };

  const menu = (
    <Menu>
      {keys.slice(3).map((key) => (
        <Menu.Item key={key}>
          <Checkbox
            onChange={() => toggleColumn(key)}
            checked={columnsVisible.includes(key)}
            onClick={(e) => e.stopPropagation()}
          >
            {key}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );

  const [activeTabs, setActiveTabs] = useState("Affected_Software");
  const callback = (activekey) => {
    setActiveTabs(activekey);
    console.log("active-key ==", activekey);
  };
  const callbackVulnerability = (activekey) => {
    setActiveTabs(activekey);
    console.log("callbackVulnerability==>>>>", activekey);
  };

  const tabsMenu = [
    {
      key: "Security",
      label: "Security",
      children: <SecurityTabs />,
    },
    { key: "Popularity", label: "Popularity", children: <PopularityTabs /> },
    { key: "Maintenance", label: "Maintenance", children: <MaintenanceTabs /> },
  ];
  const tabsMenuVulnerability = [
    {
      key: "Vulnerability_Details",
      label: "Vulnerability Details",
      children: <CollapseTopIssues />,
    },
    {
      key: "Affected_Software",
      label: "Affected Software",
      children: <AffectedSoftware />,
    },
    {
      key: "Solution_Fix",
      label: "Solution & Fix",
      children: <SolutionFix />,
    },
    {
      key: "References",
      label: "References",
      children: <References />,
    },
  ];
  // smalll modalPop for click delete btn on extrabtn tabsWithBtn components start
  const [openSmalModal, setOpenSmalModal] = useState(false);
  const handleCloseSmallModal = () => {
    setOpenSmalModal(false);
  };
  const handleOpenSmallModal = () => {
    setOpenSmalModal(true);
  };
  // smalll modalPop for click delete btn on extrabtn tabsWithBtn components end
  // extra btn for tabsWithBtn components
  const operations = (
    <div className="extra_btn">
      <Button
        onClick={handleOpenSmallModal}
        icon={<DeleteOutlined />}
        style={{ borderColor: "#1677ff", color: "#1677ff" }}
      >
        Delete
      </Button>
      <Button
        icon={<EditOutlined />}
        style={{ borderColor: "#1677ff", color: "#FFF", background: "#5A81FA" }}
      >
        Edit
      </Button>
    </div>
  );
  // end
  // steps menu send to steps FormSteps component start
  const steps = [
    {
      title: "Application Information",
      content: <DynamicForm data={applicationInfoFormData} />,
    },
    {
      title: "Developer Information",
      content: <DynamicForm data={applicationInfoFormData} />,
    },
    {
      title: "Other Information",
      content: <DynamicForm data={applicationInfoFormData} />,
    },
  ];
  const handleCellClick = (columnKey, text, record) => {
    if (columnKey === "Affected Assets") {
      setOpenDrawer(true);
      console.log("Clicked on Affected Software column", text);
    } else {
      // Perform action for other columns if needed
      console.log(`Clicked on ${columnKey} column`, text);
    }
    console.log("inside click of col", text, record);
  };
  const itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  };
  const [currentPage, setCurrentPage] = useState(1);
  const totalRecords = 100; // Total number of records in your table
  const pageSize = 10; // Number of records per page

  const startRecord = (currentPage - 1) * pageSize + 1;
  const endRecord = Math.min(currentPage * pageSize, totalRecords);

  // const [open, setOpen] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  return (
    <>
      <div className="common_table">
        <Row gutter={[16, 16]}>
          {showGlobalFilter ? (
            <Col
              xs={showGlobalFilter ? 24 : 0}
              sm={showGlobalFilter ? 24 : 0}
              md={showGlobalFilter ? 6 : 0}
            >
              <GlobalFilter />
            </Col>
          ) : null}
          <Col xs={24} sm={24} md={showGlobalFilter ? 18 : 24}>
            <div className="table_row d-flex justify-content-between align-items-center mb-2">
              <div
                className="wrapper_left"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Dropdown overlay={menu} trigger={["click"]}>
                  <a
                    className="column-icon"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Columns
                    <SplitscreenOutlinedIcon
                      style={{ color: "#63637D", width: 15, fontSize: 13 }}
                    />
                  </a>
                </Dropdown>
                <RowSelectBtn />
                {!showGlobalFilter ? (
                  <a className="filter_label_btn">
                    <span className="filter_label_btn_btn_text"> Filter</span>
                    <CloseOutlined style={{ color: "#fff" }} />
                  </a>
                ) : null}
              </div>
              <div
                className="right_div"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div className="filter_switch">
                  <Switch
                    size="small"
                    className="custom_switch"
                    defaultChecked
                    onChange={handleSwitchFilter}
                  />
                  <span className="ms-1">Filter</span>
                </div>
                <div className="card_view">
                  <button className="card_view_btn" onClick={toggleTableView}>
                    <img src={CardViewIcon} alt="card_view" />
                    <span className="card_view_text"> Card View</span>
                  </button>
                </div>
                <div className="download_excel d-flex align-items-center">
                  <button
                    // icon={<DownloadOutlined style={{fontSize: 15}} />}
                    style={{ borderColor: "#5A81FA" }}
                    className="btn download_excel_btn btn-outlined  d-flex align-items-center "
                  >
                    <DownloadOutlined style={{ fontSize: 15 }} />
                    Download Excel
                  </button>
                </div>
                <div className="add_andriod">
                  <button
                    className="add_andriod_btn"
                    onClick={openAndriodModal}
                    // icon={<PlusOutlined />}
                    type="primary"
                  >
                    <PlusOutlined style={{ color: "#FFFFFF", fontSize: 15 }} />
                    Add Andriod
                  </button>
                </div>
              </div>
            </div>
            {!tableView ? (
              <>
                <Table
                  dataSource={data}
                  className="vulnerability_custom_table"
                  size="small"
                  scroll={{ x: true }}
                  columns={keys
                    .filter((key) => columnsVisible.includes(key))
                    .slice(3)
                    .map((key) => ({
                      title: key,
                      dataIndex: key,
                      key: key,
                      ellipsis: true,
                      sorter: (a, b) => {
                        const valueA = a[key] || "";
                        const valueB = b[key] || "";
                        return valueA.localeCompare(valueB);
                      },
                      render: (text, record) => {
                        if (key === "Affected Assets" || key === "CVE Value") {
                          // Check if it's the affected assets column
                          return {
                            children: (
                              <div
                                className="affected-assets"
                                onClick={() =>
                                  handleCellClick(key, text, record)
                                }
                              >
                                {" "}
                                {text}{" "}
                              </div>
                            ),
                            // children: <div className="affected-assets">{text}</div>, // Apply style to the column
                          };
                        } else if (text === "False") {
                          return {
                            children: <div className="license"> {text} </div>,
                          };
                        } else if (text === "True") {
                          return {
                            children: (
                              <div className="license-true"> {text} </div>
                            ),
                          };
                        } else {
                          return {
                            children: <div> {text} </div>,
                          };
                        }
                      },
                    }))}
                  {...(applyOnRowHandler
                    ? {
                        onRow: (record) => ({
                          onClick: () => {
                            setSelectedRow(record);
                            showDrawerModal();
                          },
                        }),
                      }
                    : componentModal
                    ? {
                        onRow: (record) => ({
                          onClick: () => {
                            setSelectedRow(record);
                            showComponentModal();
                          },
                        }),
                      }
                    : {})}
                  pagination={false}
                  rowKey={(record, index) => index}
                />
              </>
            ) : (
              <DataGridCard />
            )}
            <div
              style={{
                display: "flex",
                marginTop: "10px",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#63637D",
                padding: "7px",
                fontWeight: 600,
                fontSize: "13px",
              }}
            >
              <div>
                Showing {startRecord}-{endRecord} entries out of {totalRecords}
              </div>
              <Pagination
                style={{
                  color: "#63637D",
                  padding: "5px",
                  fontWeight: 600,
                  fontSize: "12px",
                }}
                current={currentPage}
                pageSize={pageSize}
                total={totalRecords}
                itemRender={itemRender}
                onChange={handlePageChange}
                showSizeChanger={false}
              />
            </div>
          </Col>
        </Row>
      </div>
      {open && (
        <Drawer
          title="MIT License 4.0"
          className="license-side-drawer"
          width={500}
          onClose={onClose}
          closeIcon={null}
          open={open}
          extra={
            <Space>
              <span onClick={onClose}>
                <CloseOutlined />
              </span>
              {/* <Button type="primary" onClick={onClose}>
                  OK
                </Button> */}
            </Space>
          }
        >
          <div>
            <div className="small-head">
              ShielderSec/webtech is licensed under the
            </div>
            <div className="main-head">GNU General Public License v2.3</div>
            <p className="paragraph">
              Permissions of this strong copyleft license are conditioned on
              making available complete source code of licensed works and
              modifications, which include larger works using a licensed work,
              under the same license. Copyright and license notices must be
              preserved. Contributors provide an express grant of patent rights.
            </p>
          </div>
          <div className="second-div">
            <div>Permissions</div>
            <div>Limitations</div>
            <div>Conditions</div>
          </div>
          <div className="main-part">
            <div>
              <div className="details">
                <ExclamationIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#FE9706", backgroundColor: "#ffeacd" }}
                />
                Commercial Use
              </div>
              <div className="details">
                <CheckIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#02B583", backgroundColor: "#e6f8f3" }}
                />
                Private Use
              </div>

              <div className="details">
                <ExclamationIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#FE9706", backgroundColor: "#ffeacd" }}
                />
                Distribution
              </div>
              <div className="details">
                <CheckIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#02B583", backgroundColor: "#e6f8f3" }}
                />
                State changing
              </div>
            </div>
            <div>
              <div className="details">
                <CrossIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#02B583", backgroundColor: "#e6f8f3" }}
                />{" "}
                Liability
              </div>
              <div className="details">
                <CrossIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#02B583", backgroundColor: "#e6f8f3" }}
                />
                Warranty
              </div>
            </div>
            <div>
              <div className="details">
                <ExclamationIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#FE9706", backgroundColor: "#ffeacd" }}
                />
                Commercial Use
              </div>
              <div className="details">
                <CheckIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#02B583", backgroundColor: "#e6f8f3" }}
                />
                Private Use
              </div>

              <div className="details">
                <ExclamationIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#FE9706", backgroundColor: "#ffeacd" }}
                />
                Distribution
              </div>
              <div className="details">
                <CheckIcon
                  className="exclamamtion-icon-style"
                  style={{ color: "#02B583", backgroundColor: "#e6f8f3" }}
                />
                State changing
              </div>
            </div>
          </div>
        </Drawer>
      )}
      {componentOpen && (
        <Drawer
          title="Component Details"
          className="component-side-drawer"
          width={550}
          onClose={onComponentClose}
          closeIcon={null}
          open={componentOpen}
          extra={
            <Space>
              <span onClick={onComponentClose}>
                <CloseOutlined />
              </span>
              {/* <Button type="primary" onClick={onClose}>
                  OK
                </Button> */}
            </Space>
          }
        >
          <Card>
            <div className="chart-design">Package Health Score</div>

            <Flex justify="space-evenly">
              <Col>
                <CommanPieChart score={79} />
              </Col>
              <Col>
                <div className="side-content pt-2 pb-2">
                  <div className="title">Security</div>
                  <div
                    className="sub-title"
                    style={{ color: "#02B583", backgroundColor: "#02B5831F" }}
                  >
                    No unknown security
                  </div>
                </div>
                <div className="side-content pt-2 pb-2">
                  <div className="title">Popularity</div>
                  <div
                    className="sub-title"
                    style={{
                      color: "#5A81FA",
                      backgroundColor: "#5A81FA1F",
                      border: "1px solid #5A81FA",
                    }}
                  >
                    Key ecosystem Project
                  </div>
                </div>
                <div className="side-content pt-2 pb-2">
                  <div className="title">Maintenance</div>
                  <div
                    className="sub-title"
                    style={{
                      color: "#02B583",
                      backgroundColor: "#5A81FA1F",
                      border: " 1px solid #02B583",
                    }}
                  >
                    Healthy
                  </div>
                </div>
              </Col>
            </Flex>
          </Card>
          <TabsWithExtraBtn
            callback={callback}
            menu={tabsMenu}
            // extraBtn={operations}
          />
        </Drawer>
      )}
      <CommonBottomDrawer
        title="Vulnerability"
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
          setActiveTabs("Affected_Software");
        }}
      >
        <Card>
          <TabsWithExtraBtn
            activeTabs={activeTabs}
            key={activeTabs}
            callback={callbackVulnerability}
            menu={tabsMenuVulnerability}
          />
        </Card>
      </CommonBottomDrawer>
    </>
  );
};

export default CustomTableVulnerabilities;
